import open from 'open';
import { appUrlForApiUrl } from '../auth/open-browser.js';
import type { LogFn } from '../log.js';
import type { E2eCertificate } from './certificates.js';

export async function openE2eCertificateImportUrl({
  apiUrl,
  workspaceId,
  certificate,
  log,
}: {
  apiUrl: string;
  workspaceId: string;
  certificate: E2eCertificate;
  log: LogFn;
}): Promise<void> {
  const appUrl = appUrlForApiUrl(apiUrl);
  const payload = encodeURIComponent(certificate.pemBundle);
  const url = `${appUrl.replace(/\/$/, '')}/w/${encodeURIComponent(workspaceId)}/settings/e2e-encryption?certificate=${payload}`;

  log(`[E2EE] Opening browser to import key "${certificate.name}" (${certificate.id})...`);
  try {
    await open(url, { wait: false });
  } catch {
    log('[E2EE] Could not open browser. Open this URL manually:');
    log(url);
  }
}
